<template>
	<div v-if="addon && addon.IsProductActive" class="addon_row">
		<div class="wrap_addon_photo">
			<img v-if="addon.PhotoVersion" :src="photo" />
		</div>
		<pre>{{ addon }}</pre>
		<section :class="{ flex: addon.IsBoolean }">
			<hgroup>
				<h4 class="mb-0">{{ addon.AddOnName }}</h4>
				<small
					class="_price text-blue"
					style="margin-top: 7px; font-size: 16px;"
				>
					<span v-if="addon.AddOnDiscount && displayPrice" class>
						<currency :className="'slash'" :value="cost" />&nbsp;
					</span>
					<currency
						v-if="addon.Variants.length == 0 && displayPrice"
						:value="displayPrice"
					/>
					<div v-if="displayPrice == 0 && addon.Variants.length == 0">
						Free!
					</div>
				</small>
				<div class="mt-0" v-html="addon.AddOnDescription"></div>
			</hgroup>
			<div>
				<pre>Min {{ myMin }}</pre>
				<variant-selector v-if="addon.Variants.length" :addon="addon" />
				<number-ticker
					v-else-if="!addon.IsBoolean && myMax != 0"
					v-model="addon.Quantity"
					:max="myMax"
					:min="myMin"
					:disableAdd="myMin == myMax"
				/>
				<div v-else-if="myMax == 0" style="color:red; margin-top: 12px;">
					Sold Out
				</div>
				<pre>Max {{ myMax }}</pre>
				<toggle
					:disabled="addon.AddOnIsRequired"
					v-if="addon.IsBoolean"
					:useInteger="true"
					:name="'select_photo_toggle_' + addon.PhotoPackageKey"
					v-model="addon.Quantity"
				/>
			</div>
		</section>
	</div>
</template>
<script>
	import NumberTicker from '../components/NumberTicker.vue';
	import VariantSelector from '../components/VariantSelector.vue';
	export default {
		props: ['addon', 'participants'],
		name: 'AddOnRow',
		computed: {
			myMax() {
				return this.addon.AddOnRequiredPerPerson
					? this.participants
					: this.addon.MaxQuantity
					? this.addon.MaxQuantity
					: this.addon.MaxQuantity == null
					? 9999
					: 0;
			},
			myMin() {
				if (this.addon.AddOnRequiredPerPerson) return this.participants;
				if (this.addon.AddOnIsRequired) return 1;
				return 0;
			},
			photo() {
				return (
					this.addon.PhotoDomain +
					'w_580' +
					'/v' +
					this.addon.PhotoVersion +
					this.addon.PhotoFolder +
					'/original'
				);
			},
			cost() {
				return this.addon.Cost
					? this.addon.Cost
					: this.addon.PublishedPrice
					? this.addon.PublishedPrice
					: 0;
			},
			displayPrice() {
				var discount = this.addon.AddOnDiscount ? this.addon.AddOnDiscount : 0;
				return this.cost - discount;
			},
		},
		components: {
			NumberTicker,
			VariantSelector,
		},
	};
</script>

<style></style>
